// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-file-input ~ .custom-file-label[data-v-4dee190b]::after {\n  content: \"Buscar\";\n}\n", ""]);
// Exports
module.exports = exports;
